import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import MainLayout from "./layouts/MainLayout";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";


/* Lazy-loaded pages */
const Home = lazy(() => import("./pages/Home"));
const Services = lazy(() => import("./pages/Services"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogDetail = lazy(() => import("./pages/Blogdetail"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Careers = lazy(() => import("./pages/Careers"));

function App() {
  return (
    <Suspense
      fallback={
        <div className="h-screen flex items-center justify-center text-sm text-gray-500">
          Loading...
        </div>
      }
    >
      {/* ✅ ADD THIS */}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="about" element={<AboutPage />} />

          {/* Blog */}
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogDetail />} />
          <Route path="Contact" element={<Contact />} />
          <Route path="Careers" element={<Careers />} />
          <Route path="services/:slug" element={<ServiceDetail />} />




          {/* ✅ ALWAYS LAST */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <BackToTop />
    </Suspense>
  );
}

export default App;